<!-- @format -->

<button
	class="icon hmf-round-radius"
	[attr.aria-label]="
		isAuthenticated()
			? productIsFavorited()
				? 'Remove from a list'
				: 'Add to a list'
			: 'Sign in to add to a list'
	"
	[class.disablePointerEvents]="actionInProgress()"
	(click)="iconClicked()"
>
	<homefield-icon
		class="icon-outlined"
		[class.icon-filled]="productIsFavorited()"
		[name]="iconName()">
	</homefield-icon>
</button>
